import type { EvalImage, FilterValues } from "../../types/creative-eval";

export const CATEGORIES = [
  { key: "subjective", label: "Subjective" },
  { key: "model_issue", label: "Model" },
  { key: "prompting_issue", label: "Prompting" },
  { key: "input_image_issue", label: "Input Image" },
  { key: "output_resolution", label: "Output Resolution" },
  { key: "unknown", label: "Unknown" }
] as const;

export const CATEGORY_OPTIONS: Record<string, readonly string[]> = {
  model_issue: ["Scale", "Fidelity", "Anatomy", "Coherence", "Object Count", "Poor Adherence", "Other"],
  prompting_issue: [
    "Conflicting Statements",
    "Excessive Details",
    "Insufficient Details",
    "Off Brand",
    "Unsupported Request",
    "Other"
  ],
  input_image_issue: [
    "Low Quality Input",
    "Missing Input Image",
    "Missing Product Reference",
    "Wrong Product Reference",
    "Bad Product Reference",
    "Bad Input Image",
    "Bad Moodboard Image",
    "Too Many Images",
    "Other"
  ]
};

export const ACTION_OPTIONS = [
  { value: "REJECTED", label: "Rejected" },
  { value: "ACCEPTED", label: "Accepted" },
  { value: "NO ACTION", label: "No Action" }
] as const;

export const MONTH_OPTIONS = [1, 2, 3, 6, 12] as const;

export const INPUT_IMAGE_GROUPS: ReadonlyArray<{
  label: string;
  key: keyof Pick<
    EvalImage,
    "reference_images" | "moodboard_images" | "previous_ad_images" | "chat_uploads" | "other_inputs"
  >;
}> = [
  { label: "Reference Images", key: "reference_images" },
  { label: "Moodboard Images", key: "moodboard_images" },
  { label: "Previous Ad Images", key: "previous_ad_images" },
  { label: "Chat Uploads", key: "chat_uploads" },
  { label: "Other Inputs", key: "other_inputs" }
] as const;

export const DEFAULT_ACTION = "REJECTED";
export const DEFAULT_BATCH_SIZE = 20;
export const MIN_BATCH_SIZE = 1;
export const MAX_BATCH_SIZE = 50;
export const INPUT_IMAGE_FIELDS = INPUT_IMAGE_GROUPS.map((group) => group.key);

export const DEFAULT_FILTER_VALUES: FilterValues = {
  brandId: null,
  userId: "",
  monthsBack: 1,
  dateStart: "",
  dateEnd: "",
  imageId: "",
  selectedActions: [DEFAULT_ACTION],
  batchSize: DEFAULT_BATCH_SIZE,
  filtersOpen: false,
  includeEvaluated: false,
  randomize: true
};

export const REVIEW_SESSION_STORAGE_KEY = "creative-eval-review-session";
export const REVIEW_SESSION_DRAFT_STORAGE_KEY = "creative-eval-review-draft";
export const REVIEW_SESSION_VERSION = 1;
export const DEBUG_QUERY_INITIAL = "No query executed yet.";
export const DEBUG_QUERY_EMPTY = "No BigQuery query returned by API.";
